import type { IRealtimeTransport, RealtimeListener, RealtimeState } from './IRealtimeTransport';
import { WebSocketTransport } from './WebSocketTransport';

export class RealtimeManager {
  private transport: IRealtimeTransport;
  private connected = false;

  constructor(transport?: IRealtimeTransport) {
    this.transport = transport ?? new WebSocketTransport();
  }

  async connect(url: string, token?: string): Promise<void> {
    if (this.connected) return;
    try {
      await this.transport.connect(url, token);
      this.connected = true;
    } catch {
      this.connected = false;
    }
  }

  disconnect(): void {
    this.transport.disconnect();
    this.connected = false;
  }

  subscribe<T = unknown>(topic: string, listener: RealtimeListener<T>): () => void {
    return this.transport.subscribe<T>(topic, listener);
  }

  publish(topic: string, payload: unknown): void {
    this.transport.publish(topic, payload);
  }

  isConnected(): boolean {
    return this.transport.isConnected();
  }

  onStateChange(cb: (s: RealtimeState) => void): () => void {
    return this.transport.onStateChange(cb);
  }
}

export const realtime = new RealtimeManager();
